<template>
    <el-dialog
        :visible="dialogVisible"
        :append-to-body="true"
        :destroy-on-close="true"
        width="760px"
        class="vip-unauth-alert"
        custom-class="vip-unauth-alert"
        @close="close"
    >   
        <div class="text-content">
            <div style="padding-right: 460px;position: relative;line-height: 38px;padding-bottom: 20px;">
                <span style="font-size: 26px;margin-bottom: 30px;display: block;">超级会员权限</span>
                1、可以下载所有平台零配件模型，包括目前限制下载的企业模型。<br/>
                2、可以申请成为平台兼职数字样本制作工程师，以便获取相关收益。<br/>
                3、可以优先成为平台合作伙伴，积极推荐供应商入网，每年获取固定提成。
                <div class="vip-qrcode">
                    <div class="vip-qrcodeview" v-loading="loading">
                        <div class="nvip-qrcode" v-show="yearQrBol">
                            <!-- <span style="font-size: 22px;font-weight: bold;margin-bottom: 10px;">199元/年</span> -->
                            <canvas id="nvipQrcode" width="200" height="200"></canvas>
                        </div>
                        <div class="jdvip-qrcode" v-show="quarterQrBol">
                            <!-- <span style="font-size: 22px;font-weight: bold;margin-bottom: 10px;">79元/季度</span> -->
                            <canvas id="jdvipQrcode" width="200" height="200"></canvas>
                        </div>
                    </div>
                    <p>微信扫码，成为超级会员</p>
                    <p>友情提示：如有其他问题，请及时联系在线客服，如果希望进一步了解大国工匠作用，请加微信19564151511。畅通交流，相互支持，共建可信供应商数据平台。</p>
                </div>
            </div>
        </div>
        <template #footer>
            <el-button
                size="medium"
                type="default"
                @click="cancel"
            >联系客服</el-button>
            <el-button
                size="medium"
                type="primary"
                @click="confirm"
            >支付完成</el-button>
        </template>
    </el-dialog>
</template>

<script>
import UQRCode from 'uqrcodejs';
import {Message} from 'element-ui'
import {Category} from '@digital-supply-chain/module'
import { ChatService, TodaySearchService } from '@/service';

  export default {
    data() {
        this.quarterQr = null;
        this.yearQr = null;
        return {
            dialogVisible: false,
            loading: false,

            yearQrBol: false,
            quarterQrBol: false,
        };
    },
    methods: {
        open() {
            this.createMemberOrder();
            this.dialogVisible = true;
        },
        close() {
			this.dialogVisible = false;
		},
		cancel() {
            ChatService.StartRecent(Category.User, 817);
		},
		confirm() {
            this.close();
		},

        async createMemberOrder() {
            this.loading = true;
            const res = await TodaySearchService.createMemberOrderList();
            this.loading = false;
            if (res.code == 0) {
                const yearOrder = res.data.find(item => item.vip.type == 'year');
                const quarterOrder = res.data.find(item => item.vip.type == 'quarter');
                const option = { margin: 8 };

                if (yearOrder) {
                    this.yearQrBol = true;
                    this.yearQr = new UQRCode();
                    this.yearQr.data = yearOrder.payUrl;
                    this.yearQr.size = 200;
                    this.yearQr.setOptions(option);
                    this.yearQr.make();
                    const yearCanvas = document.getElementById("nvipQrcode");
                    const yearCanvasContext = yearCanvas.getContext("2d");
                    this.yearQr.canvasContext = yearCanvasContext;
                    this.yearQr.drawCanvas();
                }

                if (quarterOrder) {
                    this.quarterQrBol = true;
                    this.quarterQr = new UQRCode();
                    this.quarterQr.data = quarterOrder.payUrl;
                    this.quarterQr.size = 200;
                    this.quarterQr.setOptions(option);
                    this.quarterQr.make();
                    const quarterCanvas = document.getElementById("jdvipQrcode");
                    const quarterCanvasContext = quarterCanvas.getContext("2d");
                    this.quarterQr.canvasContext = quarterCanvasContext;
                    this.quarterQr.drawCanvas();
                }
            }
        },
    }
  };
</script>

<style lang="less">
    .vip-unauth-alert{
        .text-content{
            font-size: 16px;
            line-height: 30px;
        }
        &.el-dialog{
            background: #ecf5ff;
            border: 1px solid #b3d8ff;
            border-radius: 28px;
        }
        .el-dialog__header{
            padding: 0;
        }
        .el-dialog__body{
            padding-top: 24px;
            padding-bottom: 0;
        }
        .el-dialog__footer{
            text-align: center;
            width: 100%;
            display: block;
        }
        .el-dialog__headerbtn{
            top: 10px;
            right: 10px;
            font-size: 20px;
        }

        .vip-qrcode{
            width: 460px;
            position: absolute;
            right: 0px;
            top: 0px;
            line-height: 26px;
            font-size: 14px;
            p{
                width: 100%;
                margin: 0;
                padding: 0 40px;
                text-align: center;
            }
        }
        .vip-qrcodeview{
            width: 100%;
            height: 236px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }
        .nvip-qrcode,.jdvip-qrcode{
            width: 230px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
</style>
